import { render, staticRenderFns } from "./RTag.vue?vue&type=template&id=4cc9f2b8&scoped=true"
import script from "./RTag.vue?vue&type=script&lang=js"
export * from "./RTag.vue?vue&type=script&lang=js"
import style0 from "./RTag.vue?vue&type=style&index=0&id=4cc9f2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc9f2b8",
  null
  
)

export default component.exports